{
  "es": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here...",
        "forName": "No se encontró %{name}",
        "hangar": "Su hangar está vacío",
        "wishlist": "Su lista de deseos está vacía",
        "features": "No hay funciones disponibles"
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "No pudimos encontrar ningún registro.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Actualmente no hay funciones de autoservicio disponibles. Vuelva más tarde, ya que se agregan nuevas funciones regularmente."
      }
    }
  },
  "en": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here..."
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "We could not find any Records.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      }
    }
  }
}
